var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6781 2.98597L11.8462 1.81784C12.4913 1.1727 13.5373 1.1727 14.1825 1.81784C14.8276 2.46298 14.8276 3.50897 14.1825 4.15411L13.0143 5.32224M10.6781 2.98597L3.81653 9.84757C2.94545 10.7186 2.50989 11.1542 2.21332 11.6849C1.91673 12.2157 1.61834 13.4689 1.33301 14.6673C2.53142 14.382 3.78467 14.0836 4.31542 13.787C4.84617 13.4904 5.28171 13.0549 6.1528 12.1838L13.0143 5.32224M10.6781 2.98597L13.0143 5.32224",
    stroke: "#8E8D89",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.16602 14.668H12.166",
    stroke: "#8E8D89",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.b33c74f3035ca000b3de034b1cf43d50.svg";
export { ForwardRef as ReactComponent };